import React, { useEffect, useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom';
import { formatPrice } from '../NumberFormat';
import { withTranslation } from 'react-i18next';
import arrows from "../../../src/assets/images/mo_icon/mo_arrow_left.svg";
import { makeAjax, respStatus, showMessage, url } from '../../helpers/global_helper';
import { getUserBalance, totalNumberOfResultInfo } from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../Pagination/Pagination';

const JackpotMoDesign = (props) => {
    const { onClose } = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [jackpotData, setJackpotData] = useState([]);
    const pageNumber = useSelector((state) => state.paginationData.pageNumber);
    const perPage = 5;
    const [loading, setLoading] = useState(false);
    const [resetPage, setResetPage] = useState(false);

    const handleResetPageNo = () => {
        setResetPage(false);
    };

    const fetchJackpotList = () => {
        setLoading(true);
        const reqData = {
            page: pageNumber,
            length: perPage,
        };

        makeAjax(url.DINGDONG_API.getJackpot, reqData).then((response) => {
            if (response.status !== respStatus["SUCCESS"]) {
                showMessage(response);
                return;
            }
            dispatch(getUserBalance());
            const apiData = response.data.data || [];
            const total = response.data.total || 0;

            // Update total for pagination
            dispatch(totalNumberOfResultInfo(total));

            setJackpotData(apiData);
        }).finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchJackpotList();
    }, [perPage, pageNumber]);

    let serialNo = (pageNumber - 1) * perPage + 1;

    return (
        <div className="mo_information jackpotContainer">
            <div className="inner_content">
                <div className="table content_wrapper ">
                    <div className="mo_pages_topbar">
                        <div className="back_arrow" onClick={() => navigate("/")}>
                            <img src={arrows} alt="arrows" />
                        </div>
                        <div className="mo_page_heading">
                            <h2>{props.t("tablejackpot")}</h2>
                        </div>
                    </div>

                    <div className="inner_container">
                        <div className="table_container">
                            <table className="table_data">
                                <thead>
                                    <tr>
                                        <th>{props.t("no")}.</th>
                                        <th>{props.t("date")}</th>
                                        <th>{props.t("eventname")}</th>
                                        <th>{props.t("prize")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jackpotData.length > 0 ? (
                                        jackpotData.map((entry, i) => {
                                            const currentSerial = serialNo++;
                                            return (
                                                <tr key={`${entry.game}-${i}`}>
                                                    <td>{currentSerial}</td>
                                                    <td>{entry.date}</td>
                                                    <td>{entry.event_name}</td>
                                                    <td>
                                                        {entry.usernames.split(',').map((name, idx) => {
                                                            const prize = entry.prize.split(',')[idx];
                                                            return (
                                                                <div key={idx}>
                                                                    {idx + 1} . {name} ({formatPrice(prize)})
                                                                </div>
                                                            );
                                                        })}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={4} style={{ textAlign: "center", color: "#fff" }}>
                                                {loading ? props.t("loading...") : props.t("data_not_found")}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Pagination resetPage={resetPage} handleResetPageNo={handleResetPageNo} />
                </div>

            </div>
        </div>
    );
};

export default withTranslation()(JackpotMoDesign);